import { Table } from '@mantine/core';

export const TableThead = ({ children }) => {
  return <Table.Thead>{children}</Table.Thead>;
};
